import { LiveNodeList } from 'live-node-list'

export default class Video {
  videos = new LiveNodeList('.video video')
  videoContainers = new LiveNodeList('.video')

  playButtons = new LiveNodeList('.video__play')

  constructor() {
    this.registerListeners()
  }

  registerListeners() {
    this.videos.addEventListener('play', evt => {
      const video = evt.currentTarget || evt.target
      const container = video.closest('.video')

      container.classList.add('video--playing')
    })

    this.videoContainers.addEventListener('click', evt => {
      evt.preventDefault()
      const container = evt.currentTarget || evt.target
      const video = container.querySelector('video')

      if(video.querySelector('source')) {
        if(container.classList.contains('video--playing')) {
          container.classList.remove('video--playing')
          video.pause()
        }
        else {
          container.classList.add('video--playing')
          video.play()
        }
      }
    })
  }
}
